import { render, staticRenderFns } from "./ScrollToBottom.vue?vue&type=template&id=4b467840"
import script from "./ScrollToBottom.vue?vue&type=script&lang=js"
export * from "./ScrollToBottom.vue?vue&type=script&lang=js"
import style0 from "./ScrollToBottom.vue?vue&type=style&index=0&id=4b467840&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports